<template>
  <v-row class="pa-0">
    <v-col cols="12">
      <v-card
        border
        class="px-4 py-2 next-email-card"
        :style="{ height: hasConversionTypes ? '150px' : '100px' }"
        @click="$emit('openPageDetails', nextEmail.id)"
      >
        <v-card-text class="d-flex col-12 px-0 py-2">
          <div class="content-wrapper">
            <v-card-title class="pa-0 next-email-title d-flex w-full justify-space-between">
              <span v-if="nextEmail && nextEmail?.firstName">
                {{ nextEmail.firstName ?? '' }} {{ nextEmail?.lastName ?? '' }}
              </span>
              <span v-else>{{ nextEmail?.email ?? '' }}</span>
              <v-tooltip
                location="top"
                v-if="nextEmail && nextEmail?.firstName"
              >
                <template #activator="{ props }">
                  <span
                    v-bind="props"
                    class="d-flex align-center"
                  >
                    <v-avatar
                      :color="getRandomColor(nextEmail.id)"
                      size="30"
                    >
                      <span class="text-white text-caption font-weight-bold">
                        {{
                          getInitials({
                            firstName: nextEmail.firstName,
                            lastName: nextEmail.lastName,
                          })
                        }}
                      </span>
                    </v-avatar>
                  </span>
                </template>
                <span v-if="nextEmail && nextEmail?.firstName">{{
                  nextEmail.firstName + ' ' + nextEmail.lastName
                }}</span>
                <span v-else>{{ $t('dashboard.next-emails.avatar-label') }}</span>
              </v-tooltip>
              <v-tooltip v-else>
                <template #activator="{ props }">
                  <span
                    v-bind="props"
                    class="d-flex align-center"
                  >
                    <v-icon
                      size="30"
                      color="grey-lighten-2"
                    >
                      mdi-account-circle avatar
                    </v-icon>
                  </span>
                </template>
                <span>{{ nextEmail?.email ?? '' }}</span>
              </v-tooltip>
            </v-card-title>
            <v-card-text class="pa-0">
              <div class="d-flex align-center">
                <span>
                  <v-tooltip location="top">
                    <template #activator="{ props }">
                      <span
                        v-bind="props"
                        class="d-flex align-center"
                      >
                        <img
                          v-if="image"
                          :src="image"
                          class="next-email-calendar"
                          alt="Next email image"
                        />
                        {{ formatDate(nextEmail.scheduledAt) }}
                      </span>
                    </template>
                    {{ $t('dashboard.next-emails.scheduled-at') }}
                  </v-tooltip>
                </span>
              </div>
            </v-card-text>
            <v-card-text class="pa-0 mt-4">
              <div
                v-for="{ type, label, color } of CONVERSION_TYPES"
                :key="type"
              >
                <v-chip
                  v-if="showAction(nextEmail, type)"
                  :color="isPropertyRequestUrgent(nextEmail, type) ? 'red-lighten-4' : color"
                  size="x-small"
                  variant="flat"
                  rounded
                  class="ml-1 float-left mb-2"
                >
                  {{ $t(label) }}
                </v-chip>
              </div>
            </v-card-text>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import image from '@/assets/img/next-email.svg'
import { getInitials } from '@/composables/useNameUtils'
import { usePropertyRequest } from '@/composables/usePropertyRequest'
import { useShowAction } from '@/composables/useShowAction'
import { formatDate } from '@/lib/dateTime'
import { CONVERSION_TYPES } from '@/modules/leads/configs/conversionTypes'
const { showAction } = useShowAction()
const { isPropertyRequestUrgent } = usePropertyRequest()

defineEmits<{
  (e: 'openPageDetails', id: string): void
}>()

defineProps<{
  hasConversionTypes: Boolean
  nextEmail: {
    id: string
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    conversionCountByType: Record<string, number>
    scheduledAt: Date
    actions: string[]
  }
}>()

const getRandomColor = (id) => {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash)
  }
  let color = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    color += ('00' + value.toString(16)).substr(-2)
  }
  return color
}
</script>

<style scoped>
.content-wrapper {
  flex: 1;
  min-width: 0;
  padding-right: 16px;
}

.content-wrapper :deep(.v-card-title) span {
  white-space: wrap;
}

.next-email-card {
  height: 150px;
  cursor: pointer !important;
  border-radius: 4px !important;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 #00000033 !important;
}

.next-email-card:hover {
  box-shadow: 5px 5px 10px 0 rgba(20, 19, 30, 0.15) !important;
}

.next-email-title {
  color: #252525;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.next-email-calendar {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}
</style>
